import React from "react";
import Header from "../Components/Header";
import { Box } from "@mui/material";

const MainLayout = ({ children }) => {
  return (
    <>
      <Header />
      <Box>{children}</Box>
    </>
  );
};

export default MainLayout;
